// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2-Tob","radioRow":"SimpleQuestionBuilderModal_radioRow__1fJa7"};